import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import { storageKeys } from 'settings';
import { APIHandler, Image, StorageHandler, Progress } from 'C4';

import fields from './fields';

const saveSubApp = async ({ pageId, type, appId }, callback) => {
  const { app } = (await APIHandler.getChapters(appId)) || {};
  const [{ chapterID: chapterId }] = app;

  const appInfo = await APIHandler.getAppInfo(appId);
  const global = { appId, chapterId, pageId, type };
  const activeSubApp = { global };

  Object.keys(fields).forEach((key) => {
    const [firstApp] = appInfo.app;
    activeSubApp[key] = {};

    fields[key].forEach((k) => {
      activeSubApp[key][k] = firstApp[k];
    });
  });

  StorageHandler.save(storageKeys.activeSubApp, activeSubApp);
  callback('/main/subApp');
};

const SubAppButton = ({ appId, customName, pageId, size, src, type, name, progress: userProgress }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [redir, setRedir] = useState('');

  const { progress, total_pages: totalPages } = userProgress;
  const percentage = useMemo(() => Math.round((progress / totalPages) * 100), [progress, totalPages]);

  useEffect(() => {
    if (src.length === 0) {
      const imageName = customName.length > 0 ? customName : 'Icon-180';
      setImageSrc(`https://front.travpromobile.com/${appId}/images/${imageName}.png`);
    }
  }, []);

  return (
    <button className="subApp__Card" onClick={() => saveSubApp({ pageId, type, appId }, setRedir)} type="button">
      <div className="subApp__Card--content">
        {redir.length === 0 && (
          <Image appId={+appId} default={size} fit="clamp" resize={false} src={imageSrc} staticImage />
        )}
        <h4>{name}</h4>
      </div>
      {type === 'training' && <Progress id={`SubAppButton_${src}`} value={percentage} />}
      {redir.length > 0 && <Redirect to={redir} />}
    </button>
  );
};

export default SubAppButton;

SubAppButton.propTypes = {
  appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customName: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  pageId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  progress: PropTypes.shape({
    progress: PropTypes.number,
    last_page: PropTypes.number,
    total_pages: PropTypes.number,
    inserted_at: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
};

SubAppButton.defaultProps = {
  appId: -1,
  customName: '',
  src: '',
  size: { height: 50, width: 50 },
  pageId: 0,
  name: 'Level II Chapter',
  type: null,
};
